
<nav class="navbar navbar-expand-lg sticky-top" appSafeArea id="myverticalNav" [class.sticky]="isSticky">
  <div class="container-fluid px-0">
    
   <div class="ms-auto d-flex  align-items-center order-lg-3">
    <div class="d-block d-md-none d-lg-none me-4">
      <button class=" d-flex align-items-center   btn btn-primary"
      (click)="goBack()"  >
       <i class="pi pi-arrow-left me-1"></i>
       {{"go_back" | translate}}
      </button>
     </div> 
    <a routerLink="/EconomicAssistance" class="btn btn-icon btn-light mx-2">
        <i class="fa-solid fa-wand-magic-sparkles"></i>
     </a>
     <select (change)="switchLanguage($event)" class="btn btn-icon btn-light me-2">
      <option value="en">En</option>
      <option value="fr">Fr</option>
    </select>
     <div class="d-none d-md-block d-lg-block">
      <button (click)="toggleFullScreen()" class="btn btn-icon btn-light me-2">
        <i class="pi pi-window-maximize"></i>
      </button>
     </div>
     <div class="d-none d-md-block d-lg-block">
     <button (click)="toggleTheme()" class="form-check form-switch theme-switch btn btn-light btn-icon rounded-circle" *ngIf="userRole=='Administrator'">
       <i class="pi pi-moon "   *ngIf="!isDarkTheme"></i>
       <i class="pi pi-moon"    *ngIf="isDarkTheme"></i>
     </button>
     </div>
    
     <ul class="navbar-nav navbar-right-wrap pe-2 flex-row">
       <li class="d-none d-md-block d-lg-block dropdown d-inline-block stopevent position-static ms-2">
         <a class="btn btn-light btn-icon rounded-circle text-muted indicator indicator-primary" href="#"
           role="button" id="dropdownNotificationSecond" data-bs-toggle="dropdown" aria-haspopup="true"
           aria-expanded="false" >
           <i class="pi pi-bell"> </i>
         </a>
         <div class="dropdown-menu dropdown-menu-end dropdown-menu-lg position-absolute mx-3 my-5"
           aria-labelledby="dropdownNotificationSecond">
           <div>
             <div class="border-bottom px-3 pb-3 d-flex justify-content-between align-items-center">
               <span class="h5 mb-0">Notifications</span>
               <a href="# " class="text-muted"><span class="align-middle"><i
                     class="fe fe-settings me-1"></i></span></a>
             </div>
             <ul class="list-group list-group-flush  scrollable-card" style="height: 300px;" data-simplebar>
               <li class="list-group-item " *ngFor="let item of notifications">
                 <div class="row">
                   <div class="col">
                     <a class="text-body" routerLink="/Notifications" >
                       <div class="d-flex">
                         <img src="../../../assets/images/203.svg" alt=""
                           class="avatar-md rounded-circle" >
                         <div class="ms-3">
                           <h5 class="fw-bold mb-1">{{item.workflowStep}}</h5>
                           <p class="mb-3 text-body truncate-text">
                           {{item.message}}
                           </p>
                           <span class="fs-6 text-muted">
                             <span class="ms-1 badge "  [ngClass]="{'bg-red': item.timestamp === latestTimestamp, 'bg-success': item.timestamp !== latestTimestamp}">{{item.timestamp | date:'MM-dd-yyyy HH:mm:ss:a'}}</span>
                           </span>
                         </div>
                       </div>
                     </a>
                   </div>

                 </div>
               </li>

             </ul>
             <div class="border-top px-3 pt-3 pb-0">
               <a routerLink="/Noitifications" class="text-link fw-semibold">See
                 All Notifications</a>
             </div>
           </div>
         </div>
       </li>
      <li class="dropdown ms-2 d-inline-block position-static d-none d-md-block d-lg-block" *ngIf="user!=null">
       <a class="rounded-circle" href="#" data-bs-toggle="dropdown" data-bs-display="static"
       aria-expanded="false">
       <div class="avatar avatar-md avatar-indicators avatar-online">
         <img alt="avatar" src="{{user.image}}" class="rounded-circle">
       </div>
       </a>
       <div class="dropdown-menu dropdown-menu-end position-absolute mx-3 my-5">
       <div class="dropdown-item">
         <div class="d-flex">
         <div class="avatar avatar-md avatar-indicators avatar-online">
           <img alt="avatar" src="{{user.image}}" class="rounded-circle">
         </div>
         <div class="ms-3 lh-1">
           <h5 class="mb-1">{{user.userName}}</h5>
           <p class="mb-0 text-muted">{{user.email}}</p>
         </div>
         </div>
       </div>
       <div class="dropdown-divider"></div>
       <ul class="list-unstyled">

        <li >
         <a class="dropdown-item" routerLink="/AccountSetting">
           <i class="pi pi-spin pi-cog me-2"></i>
           {{ 'Account Setting' | translate }}
         </a>
         </li>

       </ul>
       <div class="dropdown-divider"></div>
       <ul class="list-unstyled">
         <li>
         <a class="dropdown-item " (click)="logOut()" >
           <i class="pi pi-power-off me-2"></i> {{"Logout" | translate}}
         </a>
         </li>
       </ul>
       </div>
      </li>
      <button (click)="sidebarVisible = true"  class=" btn btn-primary btn-icon d-block d-md-none d-lg-none ms-2" *ngIf="userRole=='Administrator'">
       <i class="pi pi-align-justify text-white"></i>
     </button>
     </ul>

   </div>
   <div>
   </div>
   <div class="collapse navbar-collapse" id="navbar-default">
    <button class="mt-3 mt-lg-0 ms-lg-3 d-flex align-items-center   btn btn-primary"
    (click)="goBack()" >
    <i class="pi pi-arrow-left me-1"></i>
     {{"go_back" | translate}}
   </button>
    <button class="mt-3 mt-lg-0 ms-lg-3 d-flex align-items-center   btn btn-primary   rounded-circle"
     (click)="toggleColumnLayout()" *ngIf="userRole=='Administrator'">
     <i class="pi pi-align-justify text-white"></i>
  </button>
     <div *ngIf="userRole=='Administrator'">
     <div class="ui-fluid d-none d-md-block">
     <p-autoComplete
     size="large"
     
     class           ="mt-3 mt-lg-0 ms-lg-10"
     [(ngModel)]     ="selectedUser"
     [suggestions]   ="users"
     (completeMethod)="searchUsers($event)"
     [field]         ="'firstName'"
     placeholder     ="Search Users"
     [dropdownMode]  ="'scroll'"
     (onSelect)      ="onSelectUser($event)"
     [appendTo]      ="'body'"
     [autoHighlight] ="true"
     [multiple]      ="true"

     >
     <ng-template let-user pTemplate="item">
       <div class="card" *ngIf="user!=null">
       <div
       class="d-flex justify-content-between align-items-center p-4">
       <div class="d-flex">
        <img *ngIf="user.image!=null" src={{user.image}} alt="" class="avatar-md rounded-circle">
       <div class="ms-3">
       <div class="mb-1 d-flex justify-content-between">
         <div> {{user.name}}  </div>
         <div> Role  <div class="badge bg-pink"> {{user.roles}}</div></div>
       </div>
       <p class="mb-0 fs-6">
         {{user.email}}
       </p>
       </div>
       </div>
       </div>
       </div>
     </ng-template>
     </p-autoComplete>

     </div>
     </div>

   </div>

   </div>
 </nav>
 <p-drawer [(visible)]="sidebarVisible" class="custom-sidebar" [style]="{ 'background-color': 'white' }">
  <div class="text-center">
    <img src="../../../assets/images/DumyUser/touch.png" alt="" style="height: 60px" class="mb-2" />
  </div>
  <div class="navbar-vertical-content" style="color: #000 !important; background-color: white !important;" >
    <div id="navbarVerticalMenu" class="nav nav-pills nav-vertical card-navbar-nav">
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/ManueDash')" routerLink="/ManueDash">
          <div class="d-flex justify-content-between">
            <i class="pi pi-objects-column u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'manue' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/Admin')" routerLink="/Admin">
          <div class="d-flex justify-content-between">
            <i class="pi pi-microsoft u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'dashboard' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/touchConnect')" routerLink="/touchConnect">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-bars u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'links' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li> -->
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/UserInterestManu')" routerLink="/UserInterestManu">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-magnet u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userInterests' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/userContacts')" routerLink="/userContacts">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-address-book u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'userContacts' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
     
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/bussinessLeadPage')" routerLink="/bussinessLeadPage">
          <div class="d-flex justify-content-between">
            <i class="fas fa-briefcase u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessLeads' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/BusinessInsights')" routerLink="/BusinessInsights">
          <div class="d-flex justify-content-between">
            <i class="fas fa-chart-line u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'businessInsights' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/EconomicAssistance')" routerLink="/EconomicAssistance">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-wand-magic-sparkles u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark ">{{ 'aiAssistance' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/EconimicNews')" routerLink="/EconimicNews">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-shekel-sign u-sidebar-nav-menu__item-icon text-dark " style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark "> {{'MENU.ECONOMIC_NEWS' | translate}}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      
     
      
      <!-- <li class="nav-item u-sidebar-nav-menu__item" id="navSetting">
        <a [ngClass]="getClassForRoute('/setting')" routerLink="/setting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-gear u-sidebar-nav-menu__item-icon text-dark" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'setting' | translate }}</span>
            <i class="pt-1 text-white"></i>
          </div>
        </a>
      </li>
       -->
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/NotificationSettingsManue')" routerLink="/NotificationSettingsManue">
          <div class="d-flex justify-content-between">
            <i class="pi pi-cog text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'notificationAlerts' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
     
     
  
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/AccountSetting')" routerLink="/AccountSetting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Account Setting' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/DeleteMyAccount')" routerLink="/DeleteMyAccount">
          <div class="d-flex justify-content-between">
            <i class="pi pi-trash text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'DeleteMyAccount' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item" id="navProfile">
        <a [ngClass]="getClassForRoute('/sitesetting')" routerLink="/sitesetting">
          <div class="d-flex justify-content-between">
            <i class="fa-solid fa-user-lock text-dark" style="font-size:18px;"></i>
            <span class="u-sidebar-nav-menu__item-title text-dark">{{ 'Menu Admin' | translate }}</span>
            <i class=" pt-1 text-white"></i>
          </div>
        </a>
      </li>
      <li class="nav-item u-sidebar-nav-menu__item d-grid" id="navProfile">
        <a class="btn btn-primary mt-2 " (click)="logut()">
          <div class="d-flex justify-content-between">
            <i class="bi bi-box-arrow-left u-sidebar-nav-menu__item-icon text-white" style="font-size: 20px;"></i>
            <span class="u-sidebar-nav-menu__item-title pt-2">{{ 'Logout' | translate }}</span>
          </div>
        </a>
      </li>
      

    </div>
  </div>
</p-drawer>
